<template>
  <div class="row">
    <div
      class="col-lg-3 col-12 d-flex"
      v-for="(slide, i) in getIndividualPricing"
      :key="i"
    >
      <div
        class="individuals-pricing-wrapper"
        :class="[
          slide?.popular && 'pricing-popular',
          slide?.type.includes('Group') && 'pricing-group',
        ]"
      >
        <div v-if="slide.popular" class="individuals-pricing-popular">
          Most Popular
        </div>
        <div
          class="individuals-pricing-tag"
          :class="slide?.type.includes('Group') && 'pricing-group-tag'"
        >
          {{ slide.type }}
        </div>
        <div class="individuals-pricing-price">
          {{ slide.price }}
        </div>
        <div class="individuals-pricing-interval">
          {{ slide.interval }}
        </div>
        <div class="individuals-pricing-noOfClases">
          <i class="mdi mdi-calendar-clock-outline"></i>
          <div>
            {{ slide.noOfClases }}
          </div>
        </div>
        <div class="individuals-pricing-desc h-100">
          {{ slide.desc }}
        </div>
        <div class="individuals-pricing-interval d-flex">
          <i class="mdi mdi-calendar-clock-outline mr-2"></i>
          {{ slide.classesPerWeek }}
        </div>
        <div>
          <md-outlined-button
            class="individuals-pricing-button"
            :class="slide?.type.includes('Group') && 'pricing-group-button'"
            @click="$router.push('/book-demo')"
            >{{ slide.button }}
            <i class="mdi mdi-arrow-right ml-2"></i>
          </md-outlined-button>
        </div>
      </div>
    </div>
    <div>
      <div class="individuals-pricing-bottom-title">First Week Free!</div>
      <div class="individuals-pricing-bottom-description">
        Enjoy a 7-day trial before your first payment. No commitment, just
        learning!
      </div>
    </div>
    <div class="mt-5">
      <md-filled-tonal-button
        class="get-started-button"
        @click="$router.push('/book-demo')"
      >
        Book Your Free Trial Now
        <i class="mdi mdi-arrow-right"></i>
      </md-filled-tonal-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["getIndividualPricing"]),
  },
};
</script>

<style></style>
